<template>
	<section>
		<div class="title">
			<div class="title-div">{{$t('all.duanyingyin')}}</div>
			<div class="fabu" @click="handleShowModal">{{$t('all.fabuduanyingyin')}}</div>
		</div>
		<div class="duanyingyin-list" v-if="videoList.length > 0">
			<div class="video-item" v-for="(item,index) in videoList" :key="item.id || index" @click="handlePlayVideo(item)">
				<img :src="getItemCover(item)" class="video-item-img" />
				<div class="video-item-content">
					<span class="video-item-content-span">{{item.title || ''}}</span>
					<span class="video-item-content-span1">{{item.duration ? formatDuration(item.duration) : '00:00'}}</span>
				</div>
				<img class="video-item-del" src="../../assets/image/shanchu_18@2x.png" alt="" @click.stop="handleDeleteVideo(item)" />
				<div class="video-item-status">{{item.status===0?$t('all.shenhezhong') :item.status ===2?$t('all.shenhejujue') :''}}</div>
			</div>
		</div>
		<kong v-if="!isLoading && loaded && videoList.length === 0" />
		
		<div class="modal-overlay" v-if="isModalVisible" @click="isModalVisible = false">
			<div class="modal-content" @click.stop>
				<div class="modal-title">{{$t('all.fabuduanyingyin')}}</div>
				<div class="modal-input-box">
					<input class="modal-input" v-model="form.title" type="text" :placeholder="$t('all.qingshurubiaoti')" />
				</div>
				<div class="modal-upload-box" @click="handleUploadClick">
					<div v-if="!form.videoUrl" class="modal-upload-content">
						<span class="modal-upload-text">{{$t('all.shangchuanduanyingyin')}}</span>
					</div>
					<div v-else class="modal-video-preview">
						<video :src="form.videoUrl" controls class="modal-video"></video>
						<span class="modal-video-name">{{form.videoName}}</span>
					</div>
				</div>
				<div v-if="uploading" class="modal-progress-box">
					<div class="modal-progress-bar">
						<div class="modal-progress-fill" :style="{ width: uploadProgress + '%' }"></div>
					</div>
					<span class="modal-progress-text">{{uploadProgress.toFixed(1)}}%</span>
				</div>
				<div class="modal-btn" :class="{ disabled: !form.title || !form.videoUrl || uploading }" @click="handlePublish">发布</div>
				<input
				  type="file"
				  ref="fileInput"
				  style="display: none"
				  accept="video/*"
				  @change="handleFileChange"
				/>
			</div>
		</div>
		
		<!-- 视频播放弹框 -->
		<div class="player-overlay" v-if="showPlayer" @click="closePlayer">
			<div class="player-modal" @click.stop>
				<div class="player-close" @click="closePlayer">&times;</div>
				<div class="player-video-wrap">
					<video 
						ref="playerVideo"
						class="player-video"
						:src="playerUrl"
						@timeupdate="onPlayerTimeUpdate"
						@loadedmetadata="onPlayerMetadata"
						@ended="onPlayerEnded"
					></video>
				</div>
				<div class="player-controls">
					<div class="player-controls-btn" @click="togglePlayerPlay">
						<span v-if="playerPlaying">&#10074;&#10074;</span>
						<span v-else>&#9654;</span>
					</div>
					<span class="player-controls-time">{{formatTime(playerCurrentTime)}}</span>
					<div class="player-controls-progress" ref="playerProgressBar" @click="seekPlayer" @mousedown="onPlayerProgressMouseDown">
						<div class="player-controls-progress-bg"></div>
						<div class="player-controls-progress-fill" :style="{ width: playerProgress + '%' }"></div>
						<div class="player-controls-progress-dot" :style="{ left: playerProgress + '%' }"></div>
					</div>
					<span class="player-controls-time">{{formatTime(playerDuration)}}</span>
					<div class="player-controls-speed" @click="togglePlayerSpeed">{{$t('all.beisu')}} x{{playerSpeed}}</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import { client as createCosClient } from '../../common/js/txycos';
import { getPresentUserVideoList, releaseVideo, deleteVideo, returnVideo } from '../../api/duanyingyin';
import kong from '../../components/kong/kong.vue';
export default {
	components: {
		kong
	},
	data() {
		return {
			isModalVisible: false,
			cosClient: null,
			form: {
				title: '',
				videoUrl: '',
				videoName: '',
				duration: 0
			},
			uploading: false,
			uploadProgress: 0,
			videoList: [],
			coverMap: {},
			queryParams: {
				page: 1,
				size: 10
			},
			hasMore: true,
			isLoading: false,
			loaded: false,
			// 视频播放弹框
			showPlayer: false,
			playerUrl: '',
			playerPlaying: false,
			playerCurrentTime: 0,
			playerDuration: 0,
			playerProgress: 0,
			playerSpeed: 1,
			playerSpeedIndex: 0,
			playerSpeeds: [1, 1.5, 2, 0.5],
			playerIsDragging: false
		}
	},
	mounted() {
		this.cosClient = createCosClient();
		this.getVideoList();
		document.addEventListener('mousemove', this.onPlayerProgressMouseMove);
		document.addEventListener('mouseup', this.onPlayerProgressMouseUp);
	},
	beforeDestroy() {
		document.removeEventListener('mousemove', this.onPlayerProgressMouseMove);
		document.removeEventListener('mouseup', this.onPlayerProgressMouseUp);
	},
	methods: {
		async getVideoList() {
			if (this.isLoading || !this.hasMore) return;
			this.isLoading = true;
			try {
				const res = await getPresentUserVideoList(this.queryParams);
				console.log('视频列表接口返回:', res);
				const data = res.data || res;
				const newList = Array.isArray(data) ? data : (data.rows || data.list || []);
				console.log('解析后的视频列表:', newList);
				if (this.queryParams.page === 1) {
					this.videoList = newList;
				} else {
					this.videoList = [...this.videoList, ...newList];
				}
				this.loadCovers(newList);
				const total = data.total || newList.length;
				const totalPages = Math.ceil(total / this.queryParams.size);
				this.hasMore = this.queryParams.page < totalPages;
			} catch (error) {
				console.error('获取短影音列表失败：', error);
			} finally {
				this.isLoading = false;
				this.loaded = true;
			}
		},
		// 供父组件调用的加载更多方法
		loadMore() {
			if (this.isLoading || !this.hasMore) return;
			this.queryParams.page++;
			this.getVideoList();
		},
		async loadCovers(list) {
			for (const item of list) {
				if (item.videoUrl && !this.coverMap[item.videoUrl]) {
					const cover = await this.getVideoCover(item.videoUrl);
					if (cover) {
						this.$set(this.coverMap, item.videoUrl, cover);
					}
				}
			}
		},
		handleShowModal(){
			this.isModalVisible = true
			this.form = {
				title: '',
				videoUrl: '',
				videoName: '',
				duration: 0
			}
			this.uploading = false
			this.uploadProgress = 0
		},
		handleUploadClick() {
			if(this.uploading) return
			this.$refs.fileInput.click();
		},
		handleFileChange(event) {
			const fileList = event.target.files;
			if (!fileList || fileList.length === 0) return;
			this.uploadVideoToCOS(fileList[0]);
			event.target.value = '';
		},
		async uploadVideoToCOS(file) {
			if (!file || !file.type.startsWith('video/')) {
				this.$message.error(this.$t('all.qingshurubiaoti'));
						return;
					}
			this.uploading = true;
			this.uploadProgress = 0;
			this.form.videoName = file.name;
			try {
				const duration = await this.getVideoDuration(file);
				this.form.duration = Math.floor(duration);
				const fileExt = file.name.split('.').pop() || 'mp4';
				const fileName = `webStorage/web_/${Date.now()}_${Math.random().toString(36).substr(2, 10)}.${fileExt}`;
				const uploadResult = await new Promise((resolve, reject) => {
					this.cosClient.putObject({
						Bucket: this.cosClient.options.bucket,
						Region: this.cosClient.options.region,
						Key: fileName,
						Body: file,
						ContentType: file.type || 'video/mp4',
						onProgress: (progressData) => {
							this.uploadProgress = progressData.percent * 100;
						}
					}, (err, result) => {
						if (err) reject(err);
						else resolve(result);
					});
				});
				const videoUrl = `https://${this.cosClient.options.bucket}.cos.${this.cosClient.options.region}.myqcloud.com/${fileName}`;
				this.form.videoUrl = videoUrl;
				this.$message.success(this.$t('all.shangchuanzhong'));
			} catch (error) {
				console.error('视频上传失败：', error);
				this.$message.error(this.$t('all.shangchuanshibai'));
			} finally {
				this.uploading = false;
			}
		},
		getVideoDuration(file) {
			return new Promise((resolve, reject) => {
				const video = document.createElement('video');
				video.preload = 'metadata';
				video.onloadedmetadata = () => {
					resolve(video.duration);
					URL.revokeObjectURL(video.src);
				};
				video.onerror = () => {
					reject(new Error('无法获取视频时长'));
					URL.revokeObjectURL(video.src);
				};
				video.src = URL.createObjectURL(file);
			});
		},
		formatDuration(seconds) {
			const mins = Math.floor(seconds / 60);
			const secs = Math.floor(seconds % 60);
			return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
		},
		getItemCover(item) {
			// 优先用接口返回的封面
			if (item.coverUrl) return item.coverUrl;
			// 其次用截图生成的封面
			if (this.coverMap[item.videoUrl]) return this.coverMap[item.videoUrl];
			// 兜底用视频URL的第一帧（有些浏览器支持）或默认图
			return item.videoUrl || '';
		},
		getCoverStyle(item) {
			let url = '';
			if (item.videoCover) {
				url = item.videoCover;
			} else if (item.videoUrl) {
				url = item.videoUrl;
			}
			return url ? {
				backgroundImage: 'url(' + url + ')',
				backgroundSize: 'cover',
				backgroundPosition: 'center'
			} : {};
		},
		handleVideoLoaded(event, item) {
			try {
				const video = event.target;
				video.currentTime = 0.1;
			} catch (e) {
				console.error('设置视频时间失败:', e);
			}
		},
		getVideoCover(videoUrl) {
			return new Promise((resolve) => {
				if (!videoUrl) {
					resolve('');
					return;
				}
				const video = document.createElement('video');
				video.src = videoUrl;
				video.crossOrigin = 'anonymous';
				video.muted = true;
				video.preload = 'metadata';
				video.currentTime = 0.1;
				video.onloadeddata = () => {
					try {
						const canvas = document.createElement('canvas');
						canvas.width = video.videoWidth;
						canvas.height = video.videoHeight;
						const ctx = canvas.getContext('2d');
						ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
						const coverUrl = canvas.toDataURL('image/jpeg', 0.8);
						resolve(coverUrl);
					} catch (e) {
						console.error('生成封面失败:', e);
						resolve('');
					}
				};
				video.onerror = () => {
					console.error('视频加载失败:', videoUrl);
					resolve('');
				};
			});
		},
		handleDeleteVideo(item) {
			const videoId = item.id || item.videoId;
			if (!videoId) {
				this.$message.error(this.$t('all.qingshurushuju'));
				return;
			}
			const status = item.status;
			let apiFunc = null;
			let confirmMsg = '';
			let successMsg = '';
			if (status === 1) {
				apiFunc = deleteVideo;
				confirmMsg = this.$t('all.confirmDelete') || '确认删除该视频？';
				successMsg = this.$t('all.shanchuchenggong') || '删除成功';
			} else if (status === 0) {
				apiFunc = returnVideo;
				confirmMsg = this.$t('all.confirmWithdraw') || '确认撤回该视频？';
				successMsg = this.$t('all.chehuichenggong') || '撤回成功';
			} else {
				this.$message.error('当前状态无法操作');
				return;
			}
			this.$confirm(confirmMsg).then(() => {
				apiFunc({ videoId }).then(res => {
					this.$message.success(res.msg);
					this.queryParams.page = 1;
					this.hasMore = true;
					this.getVideoList();
				}).catch(err => {
					this.$message.error(err.message || '操作失败');
				});
			}).catch(() => {});
		},
		handlePublish(){
			if(!this.form.title || !this.form.videoUrl){
				this.$message.error(this.$t('all.qingshurucontent'));
				return;
			}
			this.uploading = true;
			try {
				const params = {
					vo: {},
					title: this.form.title,
					videoUrl: this.form.videoUrl,
					coverUrl: '',
					duration: this.form.duration
				};
				releaseVideo(params).then(res => {
					this.$message.success(this.$t('all.fabuchenggong'));
					this.isModalVisible = false;
					this.queryParams.page = 1;
					this.hasMore = true;
					this.getVideoList();
					this.form = {
						title: '',
						videoUrl: '',
						videoName: '',
						duration: 0
					};
				}).catch(err => {
					this.$message.error(err.message || this.$t('all.fabushibai'));
				}).finally(() => {
					this.uploading = false;
				});
			} catch (error) {
				this.uploading = false;
				this.$message.error(this.$t('all.fabushibai'));
			}
		},
		// 视频播放弹框
		handlePlayVideo(item) {
			if (!item.videoUrl) return;
			this.playerUrl = item.videoUrl;
			this.showPlayer = true;
			this.playerPlaying = false;
			this.playerCurrentTime = 0;
			this.playerProgress = 0;
			this.playerSpeed = 1;
			this.playerSpeedIndex = 0;
			this.$nextTick(() => {
				const video = this.$refs.playerVideo;
				if (video) {
					video.playbackRate = 1;
					video.play();
					this.playerPlaying = true;
				}
			});
		},
		closePlayer() {
			const video = this.$refs.playerVideo;
			if (video) video.pause();
			this.showPlayer = false;
			this.playerPlaying = false;
		},
		togglePlayerPlay() {
			const video = this.$refs.playerVideo;
			if (this.playerPlaying) {
				video.pause();
			} else {
				video.play();
			}
			this.playerPlaying = !this.playerPlaying;
		},
		onPlayerTimeUpdate() {
			if (this.playerIsDragging) return;
			const video = this.$refs.playerVideo;
			this.playerCurrentTime = video.currentTime;
			this.playerProgress = this.playerDuration > 0 ? (this.playerCurrentTime / this.playerDuration) * 100 : 0;
		},
		onPlayerMetadata() {
			this.playerDuration = this.$refs.playerVideo.duration;
		},
		onPlayerEnded() {
			this.playerPlaying = false;
			this.playerProgress = 0;
			this.playerCurrentTime = 0;
		},
		seekPlayer(e) {
			if (this.playerIsDragging) return;
			const bar = this.$refs.playerProgressBar;
			const rect = bar.getBoundingClientRect();
			const percent = (e.clientX - rect.left) / rect.width;
			this.updatePlayerProgress(percent);
		},
		onPlayerProgressMouseDown(e) {
			this.playerIsDragging = true;
			const bar = this.$refs.playerProgressBar;
			const rect = bar.getBoundingClientRect();
			const percent = (e.clientX - rect.left) / rect.width;
			this.updatePlayerProgress(percent);
		},
		onPlayerProgressMouseMove(e) {
			if (!this.playerIsDragging) return;
			const bar = this.$refs.playerProgressBar;
			const rect = bar.getBoundingClientRect();
			let percent = (e.clientX - rect.left) / rect.width;
			percent = Math.max(0, Math.min(1, percent));
			this.updatePlayerProgress(percent);
		},
		onPlayerProgressMouseUp() {
			if (this.playerIsDragging) {
				this.playerIsDragging = false;
			}
		},
		updatePlayerProgress(percent) {
			this.playerProgress = percent * 100;
			this.playerCurrentTime = percent * this.playerDuration;
			if (this.$refs.playerVideo) {
				this.$refs.playerVideo.currentTime = this.playerCurrentTime;
			}
		},
		togglePlayerSpeed() {
			this.playerSpeedIndex = (this.playerSpeedIndex + 1) % this.playerSpeeds.length;
			this.playerSpeed = this.playerSpeeds[this.playerSpeedIndex];
			this.$refs.playerVideo.playbackRate = this.playerSpeed;
		},
		formatTime(seconds) {
			if (!seconds || isNaN(seconds)) return '00:00';
			const min = Math.floor(seconds / 60);
			const sec = Math.floor(seconds % 60);
			return `${String(min).padStart(2, '0')}:${String(sec).padStart(2, '0')}`;
		}
	}
}
</script>

<style scoped lang="scss">
	.title{
		display: flex;
		flex-direction: row;
		align-items: center;
		margin-top: 32px;
	}
	.title-div{
		font-family: MiSans, MiSans;
		font-weight: 500;
		font-size: 18px;
		color: #FFFFFF;
	}
	.fabu{
		margin-left: 20px;
		padding: 9px 14px;
		background: linear-gradient( 86deg, #369AFF 0%, #8200CB 96.49%);
		border-radius: 18px;
		font-family: MiSans, MiSans;
		font-weight: 500;
		font-size: 12px;
		color: #FFFFFF;
		text-align: center;
		cursor: pointer;
	}
	.duanyingyin-list{
		display: flex;
		flex-wrap: wrap;
		align-items: flex-start;
		margin-top: 20px;
	}
	.kong{
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		width: 100%;
		padding: 60px 0;
	}
	.video-item{
		width: calc((100% - 60px) / 5);
		margin: 0px 12px 12px 0px;
		display: flex;
		flex-direction: column;
		border-radius: 20px;
		overflow: hidden;
		position: relative;
		aspect-ratio: 3 / 4; 
		cursor: pointer;
	}
	.video-item-del{
		position: absolute;
		right: 6px;
		top: 6px;
		width: 18px;
		height: 18px;
		opacity: 0;
		transition: opacity 0.2s ease;
	}
	.video-item:hover .video-item-del{
		opacity: 1;
	}
	.video-item-status{
		position: absolute;
		top: 4px;
		left: 6px;
		padding: 2px 6px;
		background: rgba(0,31,37,0.4);
		border-radius: 9px;
		border: 1px solid rgba(0,217,255,0.26);
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 10px;
		color: #00D9FF;
	}
	.video-item-img {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
	.video-item-content{
		position: absolute;
		left: 10px;
		right: 10px;
		bottom: 10px;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
	}
	.video-item-content-span{
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 16px;
		color: #FFFFFF;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		-webkit-box-orient: vertical;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	.video-item-content-span1{
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 14px;
		color: #FFFFFF;
	}
	
	.modal-overlay{
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background: rgba(0,0,0,0.6);
		display: flex;
		align-items: center;
		justify-content: center;
		z-index: 99;
	}
	.modal-content{
		width: 500px;
		background: #252632;
		border-radius: 20px;
		padding: 30px;
		box-shadow: 0px 4px 48px 0px rgba(0,0,0,0.5);
	}
	.modal-title{
		font-family: MiSans, MiSans;
		font-weight: 500;
		font-size: 20px;
		color: #FFFFFF;
		text-align: center;
		margin-bottom: 20px;
	}
	.modal-input-box{
		margin-bottom: 15px;
	}
	.modal-input{
		width: 100%;
		height: 45px;
		background: rgba(255,255,255,0.1);
		border-radius: 10px;
		border: none;
		outline: none;
		padding: 0px 15px;
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 16px;
		color: #FFFFFF;
		box-sizing: border-box;
	}
	.modal-input::placeholder{
		color: rgba(255,255,255,0.5);
	}
	.modal-upload-box{
		width: 100%;
		height: 300px;
		border: 2px dashed rgba(255,255,255,0.3);
		border-radius: 10px;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		margin-bottom: 15px;
		background: rgba(255,255,255,0.05);
		overflow: hidden;
	}
	.modal-upload-content{
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.modal-upload-text{
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 16px;
		color: #0A99F3;
	}
	.modal-video-preview{
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
	.modal-video{
		width: 100%;
		height: 260px;
		object-fit: contain;
		border-radius: 5px;
	}
	.modal-video-name{
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 12px;
		color: rgba(255,255,255,0.6);
		margin-top: 8px;
	}
	.modal-progress-box{
		display: flex;
		flex-direction: row;
		align-items: center;
		margin-bottom: 15px;
		gap: 10px;
	}
	.modal-progress-bar{
		flex: 1;
		height: 6px;
		background: rgba(255,255,255,0.2);
		border-radius: 3px;
		overflow: hidden;
	}
	.modal-progress-fill{
		height: 100%;
		background: linear-gradient(90deg, #369AFF 0%, #8200CB 100%);
		border-radius: 3px;
		transition: width 0.2s ease;
	}
	.modal-progress-text{
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 14px;
		color: rgba(255,255,255,0.8);
		min-width: 60px;
		text-align: right;
	}
	.modal-btn{
		width: 100%;
		height: 50px;
		background: linear-gradient( 81deg, #369AFF 0%, #8200CB 88.07%);
		border-radius: 10px;
		font-family: MiSans, MiSans;
		font-weight: 500;
		font-size: 18px;
		color: #FFFFFF;
		line-height: 50px;
		text-align: center;
		cursor: pointer;
		transition: opacity 0.3s ease;
	}
	.modal-btn.disabled{
		
	}

	/* 视频播放弹框 */
	.player-overlay{
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background: rgba(0,0,0,0.8);
		display: flex;
		align-items: center;
		justify-content: center;
		z-index: 9999;
	}
	.player-modal{
		width: 800px;
		max-width: 90vw;
		background: #1E2030;
		border-radius: 16px;
		overflow: hidden;
		position: relative;
	}
	.player-close{
		position: absolute;
		top: 10px;
		right: 14px;
		font-size: 28px;
		color: #FFFFFF;
		cursor: pointer;
		z-index: 10;
		line-height: 1;
	}
	.player-video-wrap{
		width: 100%;
		background: #000;
	}
	.player-video{
		width: 100%;
		max-height: 500px;
		object-fit: contain;
		display: block;
	}
	.player-controls{
		display: flex;
		flex-direction: row;
		align-items: center;
		padding: 12px 16px;
		gap: 12px;
	}
	.player-controls-btn{
		width: 32px;
		height: 32px;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		color: #FFFFFF;
		font-size: 14px;
		flex-shrink: 0;
	}
	.player-controls-time{
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 13px;
		color: rgba(255,255,255,0.8);
		flex-shrink: 0;
		min-width: 40px;
	}
	.player-controls-progress{
		flex: 1;
		height: 20px;
		display: flex;
		align-items: center;
		position: relative;
		cursor: pointer;
	}
	.player-controls-progress-bg{
		position: absolute;
		left: 0;
		right: 0;
		height: 4px;
		background: rgba(255,255,255,0.2);
		border-radius: 2px;
	}
	.player-controls-progress-fill{
		position: absolute;
		left: 0;
		height: 4px;
		background: #FFFFFF;
		border-radius: 2px;
	}
	.player-controls-progress-dot{
		position: absolute;
		width: 12px;
		height: 12px;
		background: #FFFFFF;
		border-radius: 50%;
		transform: translateX(-50%);
	}
	.player-controls-speed{
		padding: 4px 10px;
		background: rgba(255,255,255,0.1);
		border-radius: 12px;
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 12px;
		color: #FFFFFF;
		cursor: pointer;
		flex-shrink: 0;
		white-space: nowrap;
	}
</style>


// WEBPACK FOOTER //
// duanyingyin.vue?0626b960